// Mock data for development - replace with API calls in production

// Mock recipients for alert notifications
export const MOCK_RECIPIENTS = [
  { id: 'user-1', name: 'John Smith', email: 'john.smith@example.com', type: 'email' },
  { id: 'user-2', name: 'Sarah Johnson', email: 'sarah.johnson@example.com', type: 'email' },
  { id: 'user-3', name: 'Mike Davis', email: 'mike.davis@example.com', type: 'email' },
  { id: 'user-4', name: 'Lisa Chen', email: 'lisa.chen@example.com', type: 'email' },
  { id: 'user-5', name: 'Project Manager', email: 'pm@example.com', type: 'email' },
  { id: 'user-6', name: 'Team Lead', email: 'team.lead@example.com', type: 'email' },
  { id: 'user-7', name: 'Emily Watson', email: 'emily.watson@example.com', type: 'email' },
  { id: 'user-8', name: 'David Brown', email: 'david.brown@example.com', type: 'email' },
  { id: 'user-9', name: 'Jessica Taylor', email: 'jessica.taylor@example.com', type: 'email' },
  { id: 'user-10', name: 'Robert Wilson', email: 'robert.wilson@example.com', type: 'email' },
  { id: 'user-11', name: 'Amanda Martinez', email: 'amanda.martinez@example.com', type: 'email' },
  { id: 'user-12', name: 'Christopher Lee', email: 'christopher.lee@example.com', type: 'email' },
  { id: 'user-13', name: 'Michelle Garcia', email: 'michelle.garcia@example.com', type: 'email' },
  { id: 'user-14', name: 'Daniel Rodriguez', email: 'daniel.rodriguez@example.com', type: 'email' },
  { id: 'user-15', name: 'Jennifer White', email: 'jennifer.white@example.com', type: 'email' },
  { id: 'slack-1', name: '#project-alpha', channel: '#project-alpha', type: 'slack' },
  { id: 'slack-2', name: '#project-beta', channel: '#project-beta', type: 'slack' },
  { id: 'slack-3', name: '#alerts', channel: '#alerts', type: 'slack' },
  { id: 'slack-4', name: '#general', channel: '#general', type: 'slack' }
];

export const PROMPT_TYPES = [
  'Context Files Builder Template',
  'Code Generation Template', 
  'Plan Generator Template'
];

export const MOCK_PROMPT_TYPES = [
  {
    id: 1,
    name: 'Context Files Builder Template',
    description: 'Templates for generating project context files like document.md, architecture.md, ai-rules.md',
    category: 'Project Setup',
    isActive: true,
    createdAt: '2024-01-15T10:00:00Z'
  },
  {
    id: 2,
    name: 'Code Generation Template',
    description: 'Templates for generating code components, APIs, and other development artifacts',
    category: 'Development',
    isActive: true,
    createdAt: '2024-01-16T10:00:00Z'
  },
  {
    id: 3,
    name: 'Plan Generator Template',
    description: 'Templates for creating development plans, task breakdowns, and project roadmaps',
    category: 'Planning',
    isActive: true,
    createdAt: '2024-01-17T10:00:00Z'
  },
  {
    id: 4,
    name: 'Bug Fix Template',
    description: 'Templates for analyzing and fixing bugs with systematic debugging approaches',
    category: 'Development',
    isActive: true,
    createdAt: '2024-01-18T10:00:00Z'
  },
  {
    id: 5,
    name: 'API Documentation Template',
    description: 'Templates for generating comprehensive API documentation and examples',
    category: 'Documentation',
    isActive: true,
    createdAt: '2024-01-19T10:00:00Z'
  },
  {
    id: 6,
    name: 'Test Case Generator',
    description: 'Templates for creating unit tests, integration tests, and test scenarios',
    category: 'Testing',
    isActive: true,
    createdAt: '2024-01-20T10:00:00Z'
  },
  {
    id: 7,
    name: 'Code Review Template',
    description: 'Templates for conducting thorough code reviews and providing feedback',
    category: 'Analysis',
    isActive: true,
    createdAt: '2024-01-21T10:00:00Z'
  },
  {
    id: 8,
    name: 'Database Schema Template',
    description: 'Templates for designing and optimizing database schemas and queries',
    category: 'Development',
    isActive: true,
    createdAt: '2024-01-22T10:00:00Z'
  },
  {
    id: 9,
    name: 'Performance Optimization',
    description: 'Templates for analyzing and improving application performance',
    category: 'Analysis',
    isActive: true,
    createdAt: '2024-01-23T10:00:00Z'
  },
  {
    id: 10,
    name: 'Security Audit Template',
    description: 'Templates for conducting security assessments and vulnerability analysis',
    category: 'Analysis',
    isActive: true,
    createdAt: '2024-01-24T10:00:00Z'
  },
  {
    id: 11,
    name: 'Deployment Guide Template',
    description: 'Templates for creating deployment instructions and CI/CD configurations',
    category: 'Documentation',
    isActive: true,
    createdAt: '2024-01-25T10:00:00Z'
  },
  {
    id: 12,
    name: 'User Story Template',
    description: 'Templates for writing detailed user stories and acceptance criteria',
    category: 'Planning',
    isActive: true,
    createdAt: '2024-01-26T10:00:00Z'
  },
  {
    id: 13,
    name: 'Refactoring Template',
    description: 'Templates for systematic code refactoring and improvement strategies',
    category: 'Development',
    isActive: true,
    createdAt: '2024-01-27T10:00:00Z'
  }
];


export const MOCK_PROMPT_TEMPLATES = [
{
    id: 1,
    name: 'Context Files Builder Template',
    type: 'Context Files Builder Template',
    content: 
`You are an AI Developer Agent responsible for generating the initial set of project context files.

Generate the following four files for the project "{{project_name}}":  
1. document.md  
2. architecture.md  
3. ai-rules.md  
4. do-not-touch.json  

Use the provided project inputs, directory structure, and repository details.

PROJECT DETAILS
Project Name: {{project_name}}
Description: {{project_description}}
Tech Stack: {{tech_stack}}
Primary Repository: {{repository_url}}

FILE GENERATION REQUIREMENTS

1. document.md
- Provide project overview, core modules, and functional flow.
- Summarize key business logic and important terminology.
- Include high-level explanation of how the project works.
- Add placeholders where info is missing using {{missing_info_note}}.

2. architecture.md
- Provide detailed architecture breakdown.
- Include directory structure, component hierarchy, API overview, integrations, and data flows.
- Describe module interactions and architectural patterns.
- Use {{file_list}} to understand the project structure.

3. ai-rules.md
- Define AI rules for coding standards, naming conventions, constraints, and project-specific guidelines.
- Include do’s and don’ts based on {{project_domain}}.
- Avoid modifying files listed in do-not-touch.json.

4. do-not-touch.json
- List files/folders that AI/UI must not modify.
- Include system-critical files, config files, environment files, build scripts, entry points.
- Use {{file_list}} to identify sensitive files.
- Include protected sections:
{
  "protected_sections": [
    {
      "file": "path/to/file",
      "start": "# START-PROTECTED",
      "end": "# END-PROTECTED"
    }
  ]
}

ADDITIONAL INPUTS
Repository Structure: {{file_list}}
Code Samples: {{code_samples}}
Business Requirements: {{business_requirements}}

OUTPUT FORMAT
Return response in JSON format:

{
  "document.md": "<content here>",
  "architecture.md": "<content here>",
  "ai-rules.md": "<content here>",
  "do-not-touch.json": { ...json here }
}

Ensure all content is complete, consistent, and tailored to the project information provided.`,
    isActive: true,
    createdAt: '2025-12-02T10:00:00Z'
  },
  {
    id: 2,
    name: 'Advanced Context Builder',
    type: 'Context Files Builder Template',
    content: 'Comprehensive analysis of:\n\n{files}\n\nInclude:\n- Architecture overview\n- Code quality assessment\n- Improvement suggestions',
    isActive: false,
    createdAt: '2024-01-16T10:00:00Z'
  },
  {
    id: 3,
    name: 'React Component Generator',
    type: 'Code Generation Template',
    content: 'Generate a React component with:\n\n- Component name: {componentName}\n- Props: {props}\n- Styling: Material-UI\n- Include TypeScript types',
    isActive: true,
    createdAt: '2024-01-17T10:00:00Z'
  },
  {
    id: 4,
    name: 'Backend API Scaffold',
    type: 'Code Generation Template',
     content: `Generate a backend API scaffold with the following specifications:

- Framework: Node.js + Express
- Database: {database} (e.g., MongoDB, PostgreSQL)
- Include CRUD endpoints for {entityName}
- Include validation and error handling
- Use TypeScript for type safety
- Include folder structure for controllers, services, models, and routes
- Add sample unit tests for each endpoint
- Include basic authentication middleware if required
- Follow project coding standards and naming conventions`,
    isActive: true,
    createdAt: '2024-01-17T10:00:00Z'
  }
];

// Mock data for project alerts
export const MOCK_PROJECT_ALERTS = [
  {
    id: 'alert-1',
    projectId: 'mock-project-1',
    projectName: 'Demo Project Alpha',
    name: 'Overdue Tasks Alert',
    condition: {
      type: 'past_due_date',
      threshold: '1 day'
    },
    actions: [
      {
        type: 'email',
        recipients: ['pm@example.com', 'team@example.com']
      }
    ],
    enabled: true,
    createdAt: '2024-01-15T10:00:00Z'
  },
  {
    id: 'alert-2',
    projectId: 'mock-project-1',
    projectName: 'Demo Project Alpha',
    name: 'Stuck Tasks Alert',
    condition: {
      type: 'stuck_in_progress',
      threshold: '3 days'
    },
    actions: [
      {
        type: 'slack',
        recipients: ['#project-alpha']
      }
    ],
    enabled: true,
    createdAt: '2024-01-16T10:00:00Z'
  },
  {
    id: 'alert-3',
    projectId: 'mock-project-1',
    projectName: 'Demo Project Alpha',
    name: 'Dependency Blocked Alert',
    condition: {
      type: 'dependency_blocked',
      threshold: '2 days'
    },
    actions: [
      {
        type: 'email',
        recipients: ['pm@example.com']
      }
    ],
    enabled: false,
    createdAt: '2024-01-17T10:00:00Z'
  },
  {
    id: 'alert-4',
    projectId: 'mock-project-2',
    projectName: 'Demo Project Beta',
    name: 'Critical Overdue Tasks',
    condition: {
      type: 'past_due_date',
      threshold: '2 days'
    },
    actions: [
      {
        type: 'email',
        recipients: ['manager@example.com', 'pm@example.com']
      },
      {
        type: 'slack',
        recipients: ['#project-beta', '#alerts']
      }
    ],
    enabled: true,
    createdAt: '2024-01-18T10:00:00Z'
  },
  {
    id: 'alert-5',
    projectId: 'mock-project-2',
    projectName: 'Demo Project Beta',
    name: 'Long Running Tasks',
    condition: {
      type: 'stuck_in_progress',
      threshold: '5 days'
    },
    actions: [
      {
        type: 'slack',
        recipients: ['#project-beta']
      }
    ],
    enabled: true,
    createdAt: '2024-01-19T10:00:00Z'
  },
  {
    id: 'alert-6',
    projectId: 'mock-project-2',
    projectName: 'Demo Project Beta',
    name: 'Blocked Dependencies',
    condition: {
      type: 'dependency_blocked',
      threshold: '1 day'
    },
    actions: [
      {
        type: 'email',
        recipients: ['team@example.com']
      }
    ],
    enabled: false,
    createdAt: '2024-01-20T10:00:00Z'
  }
];


